import { Logout as LogoutIcon } from '@mui/icons-material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AuditStoreContext } from '@/contexts/AuditStoreProvider';
import { useLogout } from '@/queries/logout';
import { useUserStore } from '@/store/userStore';
import { checkUnsavedChanges } from '@/utils/unsavedChanges';

import { MenuItem } from '../menu-item';

type LogoutProps = {
  openLogoutModal: () => void;
};

export const Logout = ({ openLogoutModal }: LogoutProps) => {
  const { t } = useTranslation();

  const auditContext = useContext(AuditStoreContext);
  const userLogout = useUserStore((state) => state.logout);

  const { mutateAsync: logout } = useLogout();

  const handleLogout = async () => {
    await logout();
    userLogout();
  };

  const onLogout = () => {
    const audit = auditContext?.getState().audit;

    // check if an audit case is currently open to determine the logout flow:
    // - if open: verify no unsaved changes exist before logging out
    // - if not: proceed with logout immediately
    const isAuditCaseOpen = !!audit;

    if (!isAuditCaseOpen) {
      handleLogout();
      return;
    }

    const lastSavedAuditBtoa = auditContext?.getState().lastSavedAuditBtoa;

    const hasUnsavedChanges = checkUnsavedChanges(lastSavedAuditBtoa, audit);

    if (hasUnsavedChanges) {
      openLogoutModal();
      return;
    }

    handleLogout();
  };

  return <MenuItem icon={<LogoutIcon />} text={t('actions.logout')} onClick={onLogout} />;
};
